import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2'
import { NgForm } from '@angular/forms'

/**
 * Services 
 */
import { GetContactInfoService } from "../../../services/receipts/getContactInfo/get-contact-info.service"
import { AddMagazineService } from "../../../services/magazine/addMagazine/add-magazine.service";

declare var $

@Component({
  selector: 'app-magazine',
  templateUrl: './magazine.component.html',
  styleUrls: ['./magazine.component.less']
})
export class MagazineComponent implements OnInit {

  @ViewChild('magazineData', null) myForm: NgForm;

  /**
     * contact search keys
     */
  keyword = 'name'
  public contactInfoData: any = []

  public reset : Boolean = true

  /**
   * skeletonLoader
   */
  public languageSkeleton = true
  public periodSkeleton = true

  public submitLoading = false



  constructor(
    private GetContactInfoService: GetContactInfoService,
    private AddMagazineService: AddMagazineService
  ) { }

  ngOnInit() {

    setTimeout(() => {
      this.languageSkeleton = false
      this.periodSkeleton = false
    }, 95)

    setTimeout(function () {
      $(`.language`).selectpicker('refresh');
    }, 100)
    setTimeout(function () {
      $(`.period`).selectpicker('refresh');
    }, 100)
  }

  async selectContact(item) {
    // let selectedContactInfo = await this.GetselectedContactInfoService.GetSelectedContactInfo(item.id)
    // let view = selectedContactInfo.data[0]
    // this.addReceiptData.email = item.email
    // this.addReceiptData.phoneNumber = view.PRIMARY_MOBILE_NO
    // this.isView = true
    // this.viewDetails = view.TITLE_NAME + " " + view.ADDRESS_LINE1 + " " + view.ADDRESS_LINE2 + " " + view.ADDRESS_LINE3 + " " + view.CITY + " " + view.PINCODE + " " + view.STATE_NAME + " " + view.COUNTRY_NAME
  }

  async magazine(value) {
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    this.submitLoading = true
    let data = {
      "partner_id": parseInt(value.contact.id),
      "language_id": parseInt(value.language),
      "expiry_date": parseInt(value.period),
      "user_id": parseInt(user_id.STAFF_ID)
    }
    await this.emptyForm()
        const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    let result = await this.AddMagazineService.addNewMagazine(data)
    if (result.status) {
      Toast.fire({
        icon: 'success',
        title: 'successfully added'
      })
      this.submitLoading = false
    } else {
      Toast.fire({
        icon: 'error',
        title: 'error'
      })
      this.submitLoading = false
    }
  }

  async emptyForm() {
    this.myForm.reset()
    this.myForm.controls['period'].reset()
    this.myForm.controls['language'].reset()
    this.myForm.controls['contact'].reset()
  }

  async onChangeContactSearch(val: string) {
    this.contactInfoData = []
    let getContactData = await this.GetContactInfoService.GetContactInfo(val)
    if (getContactData.data.length != 0) {
      getContactData.data.forEach(element => {
        this.contactInfoData.push({ id: element.PARTNER_ID, name: `${element.PARTNER_ID} - ${element.FULL_NAME} - ${element.PRIMARY_MOBILE_NO} - ${element.EMAIL_ID}`, email: element.EMAIL_ID })
      });
    }
  }
  // async onFocusedContactSearch(e) {
  //   let getContactData = await this.GetContactInfoService.GetContactInfo("pr")
  //   if (getContactData.data.length != 0) {
  //     getContactData.data.forEach(element => {
  //       this.contactInfoData.push({ id: element.PARTNER_ID, name: `${element.PARTNER_ID} - ${element.FULL_NAME} - ${element.PRIMARY_MOBILE_NO} - ${element.EMAIL_ID}`, email: element.EMAIL_ID })
  //     });
  //   }
  // }

}
